<template>
	<div @click.stop="selectImage" :style="background" class="iFile">
		<slot>
			<div class="pt5 pb5 text-center f12 c999">{{ addText }}</div>
		</slot>
		<div class="remove" v-if="clearAble" @click.stop="$emit('onClear')"><van-icon name="clear" /></div>
	</div>
</template>

<script>
import { defalutMixin } from '../mixins/mixin';
export default {
	name: 'iFile',
	mixins: [defalutMixin],
	props: {
		gray: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		onlycamera: {
			type: Boolean,
			default: false
		},
		clearAble: {
			type: Boolean,
			default: false
		},
		bg: '',
		beforeCall: {
			type: Function,
			default: undefined
		},
		addText: {
			type: String,
			default() {
				return '添加照片';
			}
		}
	},
	data() {
		return {
			base64: ''
		};
	},
	computed: {
		background() {
			if (this.bg) {
				return {
					borderColor: this.bg || this.gray ? 'rgba(0,0,0,0.1)' : '#4C78FF',
					backgroundImage: 'url(' + (this.base64 || this.bg) + ')',
					'background-repeat': 'no-repeat',
					'background-size': 'contain',
					'background-position': 'center'
				};
			} else {
				return {
					borderColor: this.bg || this.gray ? 'rgba(0,0,0,0.1)' : '#4C78FF'
				};
			}
		}
	},
	methods: {
		selectImage() {
			if (this.readonly) {
				return;
			}
			if (this.beforeCall) {
				this.beforeCall(() => {
					this._file(
						(Data, b64) => {
							if (b64) {
								this.base64 = b64;
							} else {
								this.base64 = '';
							}

							this.$emit('change', Data);
						},
						'',
						'',
						this.onlycamera
					);
				});
			} else {
				this._file(
					(Data, b64) => {
						if (b64) {
							this.base64 = b64;
						} else {
							this.base64 = '';
						}
						//console.log(Data)
						this.$emit('change', Data);
					},
					'',
					'',
					this.onlycamera
				);
			}
		}
	}
};
</script>

<style lang="less" scoped>
.iFile {
	width: calc(100vw / 4);
	position: relative;
	height: calc(100vw / 4);
}
</style>
